import React from "react";
import styles from "./styles/Terms.module.css";
import { useLanguage } from "../LanguageContext";

function Terms() {
    const { t } = useLanguage();
    const termsData = t("terms.data");

    return (
        <div className={styles.terms}>
            <h1>{t("terms.heading")}</h1>
            <div className={styles.termsTitle}>
                <span>{t("terms.creditTerms")}</span>
            </div>
            <div className={styles.termsItems}>
                {termsData.map((term, index) => (
                    <div key={index} className={styles.termsItem}>
                        <div className={styles.termLabel}>{term.label}</div>
                        <div className={styles.termValue}>
                            <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="3.5" cy="3.5" r="3.5" fill="#D4D4D4" />
                            </svg>
                            {term.value}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Terms;
